import type { UserGroupsLocale } from './en'

export const userGroupsKo = {
  common: {
    cancel: `취소`,
    close: `닫기`,
    delete: `삭제`,
    error: `오류`,
    yes: `예`,
    no: `아니요`,
    requirePin: `PIN 필요`,
    pin: `PIN`,
    auto: `자동`,
  },
  list: {
    title: `사용자 그룹`,
    searchPlaceholder: `이름 또는 구성원으로 검색...`,
    searchAriaLabel: `사용자 그룹 검색`,
    createNew: `새 사용자 그룹`,
    createNewAriaLabel: `새 사용자 그룹 만들기`,
    tableAriaLabel: `사용자 그룹 표`,
    loading: `사용자 그룹 로드 중...`,
    noResultsTitle: `결과를 찾을 수 없음`,
    noResultsDescription: `검색어를 조정해 보세요`,
    emptyTitle: `아직 사용자 그룹이 없습니다`,
    emptyDescription: `첫 사용자 그룹을 만들어 시작하세요`,
    autoGeneratedDeleteTooltip: `자동 생성된 그룹은 삭제할 수 없습니다`,
    truncatedWarning: `사용자 그룹 {{total}}개 중 처음 {{shown}}개를 표시하고 있습니다. 일부 그룹이 표시되지 않습니다. 지원팀에 문의하세요.`,
    actionsForGroup: `{{name}} 작업`,
    editGroup: `{{name}} 편집`,
    deleteGroup: `{{name}} 삭제`,
    deleteGroupDisabled: `{{name}} 삭제(비활성화됨)`,
    accessAria: `{{label}}: {{status}}`,
    column: {
      name: `이름`,
      members: `구성원`,
      internal: `내부`,
      local: `로컬`,
      longDistance: `장거리`,
      domesticLongDistance: `장거리`,
      international: `국제`,
      action: `작업`,
    },
    pagination: {
      perPage: `페이지당:`,
      total: `(총 {{count}}개)`,
      resultsPerPage: `페이지당 결과 수`,
      previousPage: `이전 페이지`,
      nextPage: `다음 페이지`,
      jumpToPage: `{{page}}페이지로 이동`,
      morePages: `더 많은 페이지`,
    },
    deleteDialog: {
      title: `사용자 그룹 삭제`,
      description: `"{{name}}"을(를) 삭제하시겠습니까? 모든 구성원 연결이 제거되며 되돌릴 수 없습니다.`,
      successTitle: `사용자 그룹 삭제됨`,
      successDescription: `"{{name}}"이(가) 삭제되었습니다.`,
      alreadyDeletedTitle: `이미 삭제됨`,
      alreadyDeletedDescription: `이 사용자 그룹을 찾을 수 없습니다. 이미 삭제되었을 수 있습니다.`,
      failedDescription: `사용자 그룹을 삭제하지 못했습니다.`,
    },
  },
  form: {
    addTitle: `사용자 그룹 추가`,
    editTitle: `사용자 그룹 편집`,
    loading: `사용자 그룹 로드 중...`,
    loadingError: `사용자 그룹 로드 오류: {{message}}`,
    autoGeneratedNotice: `자동 생성된 그룹 - 일부 필드는 제한됩니다.`,
    nameLabel: `이름`,
    namePlaceholder: `그룹 이름 입력`,
    nameRequired: `이름은 필수입니다.`,
    nameMaxLength: `이름은 64자 이하여야 합니다.`,
    accessPermissions: `액세스 권한`,
    members: `구성원`,
    createUserGroup: `사용자 그룹 만들기`,
    saveChanges: `변경 사항 저장`,
    access: {
      internal: `내부`,
      local: `로컬`,
      domesticLongDistance: `국내 장거리`,
      international: `국제`,
      tollNumbers: `유료 번호`,
      maliciousAreaCodes: `악성 지역 번호`,
      superAccess: `슈퍼 액세스`,
      eavesdropping: `도청`,
      promptRecording: `프롬프트 녹음`,
    },
    memberPicker: {
      placeholder: `구성원 선택...`,
      searchPlaceholder: `구성원 필터...`,
      emptyLabel: `이 PBX에 할당된 사용자가 없습니다.`,
      noResultsLabel: `필터와 일치하는 사용자가 없습니다.`,
      summary_one: `구성원 {{count}}명 선택됨`,
      summary_other: `구성원 {{count}}명 선택됨`,
    },
  },
  toast: {
    createdTitle: `사용자 그룹 생성됨`,
    updatedTitle: `사용자 그룹 업데이트됨`,
    authRequiredTitle: `인증 필요`,
    authRequiredDescription: `세션이 만료되었을 수 있습니다. 다시 인증한 후 시도하세요.`,
    createFailedTitle: `사용자 그룹 생성 실패`,
    updateFailedTitle: `사용자 그룹 업데이트 실패`,
  },
} satisfies UserGroupsLocale
